import { NumberField } from '@base-ui/react/number-field';
import type { ComponentPropsWithRef } from 'react';

import { useNumberInputContext } from '@/components/Form/inputs/NumberInput/NumberInputContext';
import { cn } from '@/lib/utils';

export type NumberInputInputRef = HTMLInputElement;

export type NumberInputInputProps = ComponentPropsWithRef<typeof NumberField.Input>;

const sizeClasses = {
  small: 'h-6 px-3 pr-7 text-sm',
  medium: 'h-8 px-3 pr-7 text-sm',
  large: 'h-10 px-3 pr-8 text-base',
};

const NumberInputInput = ({ ref, className, ...props }: NumberInputInputProps) => {
  const { size } = useNumberInputContext();

  return (
    <NumberField.Input
      ref={ref}
      data-slot="input-group-control"
      className={cn(
        'w-full min-w-0 rounded-none border-0 bg-transparent py-0 shadow-none ring-0 outline-none focus:border-transparent focus:ring-0 disabled:bg-transparent',
        'focus:shadow-none data-invalid:border-0',

        sizeClasses[size as keyof typeof sizeClasses],
        className,
      )}
      {...props}
    />
  );
};

NumberInputInput.displayName = 'NumberInputInput';

export default NumberInputInput;
